import axios from 'axios'
import base from '../../base'
import resource from './resource'
import {
  REQUEST_INTERESSE_SUCCESS,
  REQUEST_DATA_SUCCESS
} from './mutation-types'

export default {
  requestData({ commit }, params) {
    const config = {
      url: resource,
      baseURL: base,
      params: params ?? { categoria: 4 }
    }
    config.params.sort = 1

    return axios(config).then(({ data }) => {
      commit(REQUEST_DATA_SUCCESS, data)
    })
  },
  requestInteresse({ commit }, Nome) {
    const config = {
      url: resource + '/EmailUsuarioInteresse',
      method: 'post',
      baseURL: base,
      data: { arquivo: Nome }
    }
    return axios(config).then(({ data }) => {
      commit(REQUEST_INTERESSE_SUCCESS, data)
    })
  }
}
